import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import { TextAreaField } from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { RetainedInformationLease } from "../partials/FormFieldsLease";
import { RetainedInformationAF } from "../partials/FormFieldsAF";
// import { Button } from "@mui/material";

// eslint-disable-next-line no-unused-vars
const RetainedForm = ({ requestData, setRequestData,filter }) => {
	const [formData, setFormData] = useState(requestData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";
	const isLeasing = filter === "lease";

	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(requestData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		console.log(formData);
		setRequestData(formData);
	};


	//editable fields for  retained assets
	const updatedData = {
		leaseData: {
			retainmentStatus: formData?.retainmentStatus,
			retainmentComment: formData?.retainmentComment,
		},
		AfData: {
			retainmentStatus: formData?.retainmentStatus,
			retainmentComment: formData?.retainmentComment,
		},
	};


	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					requestData={formData}
					action={action}
					setAction={setAction}
					handleCancel={handleCancel}
					updatedData={updatedData}
				/>

				<div className='RightSection'>
					<FormAccordion title='Retainment Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							{isLeasing ? (
								<RetainedInformationLease
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
								/>
							) : (
								<RetainedInformationAF
									formData={formData}
									isEditable={isEditable}
									handleInputChange={handleInputChange}
								/>
							)}
						</div>
					</FormAccordion>

					<FormAccordion title='Comment' open={true}>
						<div className='form-group'>
							<TextAreaField
								name='retainmentComment'
								isEditable={isEditable}
								value={formData?.retainmentComment || formData?.productId?.comment}
								handleChange={handleInputChange}
							/>
						</div>
					</FormAccordion>
{/* 
					<div className='flex'>
						<Button variant='contained' type='submit'>
							Save
						</Button>

						<Button variant='outlined' onClick={handleCancel}>
							Cancel
						</Button>
					</div> */}
				</div>
			</StyledForm>
		</>
	);
};

// Props Validation
RetainedForm.propTypes = {
	requestData: PropTypes.object,
	setRequestData: PropTypes.func,
	filter: PropTypes.string,
};

export default RetainedForm;
